import type { ReactNode } from "react";
import { Menu } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useSidebar } from "@/components/ui/sidebar";
import affiniaLogo from "@/assets/affinia-logo.png";


export function MobileNavTrigger({ className = "" }: { className?: string }) {
  const { setOpenMobile } = useSidebar();

  return (
    <Button
      variant="ghost"
      size="icon"
      className={`shrink-0 md:hidden ${className}`}
      aria-label="Open navigation"
      onClick={() => setOpenMobile(true)}
    >
      <Menu className="h-5 w-5" />
    </Button>
  );
}

interface MobileTopBarProps {
  title?: string;
  actions?: ReactNode;
}

export function MobileTopBar({ title, actions }: MobileTopBarProps) {
  return (
    <header className="pt-safe sticky top-0 z-30 flex shrink-0 items-center gap-2 border-b border-border bg-background/95 px-2 py-2 backdrop-blur supports-[backdrop-filter]:bg-background/80 md:hidden">
      <MobileNavTrigger />

      {title ? (
        <h1 className="min-w-0 flex-1 truncate text-sm font-semibold text-foreground">{title}</h1>
      ) : (
        <img
          src={affiniaLogo}
          alt="Affinia"
          className="h-7 min-w-0 flex-1 object-contain object-left dark:brightness-0 dark:invert"
        />
      )}

      {actions ? <div className="flex shrink-0 items-center gap-1">{actions}</div> : null}
    </header>
  );
}

export default MobileTopBar;
